import {
  CHANGEREQ_REQUEST, GET_CHANGEREQS_SUCCESS,
  ADD_CHANGEREQ_SUCCESS, UPDATE_CHANGEREQ_SUCCESS,
} from '../constant';

const initial = { requests: [], loading: false };

export const changeRequestReducer = (state = initial, action) => {
  switch (action.type) {
    case CHANGEREQ_REQUEST:
      return { ...state, loading: true };
    case GET_CHANGEREQS_SUCCESS:
      return { ...state, loading: false, requests: action.payload };
    case ADD_CHANGEREQ_SUCCESS:
      return { ...state, requests: [action.payload, ...state.requests] };
    case UPDATE_CHANGEREQ_SUCCESS:
      return {
        ...state,
        requests: state.requests.map(r => r._id === action.payload._id ? action.payload : r),
      };
    default:
      return state;
  }
};
